import { z } from 'zod';

export const AgentIdSchema = z.guid().brand<'AgentId'>();

export type AgentId = z.infer<typeof AgentIdSchema>;

// Canonical platform vocabulary for an assignable actor: `agent` = a
// LangChain AI agent; `operator` = a kanban operator (human) who works the
// card/task. (`customer`/`system` from the message-author vocabulary don't
// apply here — you don't assign work to the customer or the platform.)
export const AgentKindSchema = z.enum(['agent', 'operator']);

export type AgentKind = z.infer<typeof AgentKindSchema>;

export const AgentExternalRefSchema = z.object({
  id: z.string().trim().min(1).max(200),
  name: z.string().trim().min(1).max(200),
});

export type AgentExternalRef = z.infer<typeof AgentExternalRefSchema>;

const AiAgentSchema = z.object({
  id: AgentIdSchema,
  kind: z.literal('agent'),
  externalRef: AgentExternalRefSchema,
});

const OperatorAgentSchema = z.object({
  id: AgentIdSchema,
  kind: z.literal('operator'),
  externalRef: AgentExternalRefSchema,
});

export const AgentSchema = z.discriminatedUnion('kind', [AiAgentSchema, OperatorAgentSchema]);

export type Agent = z.infer<typeof AgentSchema>;
export type AiAgent = z.infer<typeof AiAgentSchema>;
export type OperatorAgent = z.infer<typeof OperatorAgentSchema>;

export const CreateAgentInputSchema = z.object({
  kind: AgentKindSchema,
  externalRef: AgentExternalRefSchema,
});

export type CreateAgentInput = z.infer<typeof CreateAgentInputSchema>;
